// 稽古を「声」が語る (配布版の既定 = a 金の囁き・2026-10-31 作者の答え「A 金の囁きとこの台本で入れる」「これで良い」。
//   開発版の比較 ?tutVoice=text|b|c|d・?tutVoice=off で声の入る前の稽古。2026-10-31 作者「チュートリアルはキャラクター『声』が説明している体で進行してほしい。
//   口調とかも揃えて。合わせて、UIとかのデザイン周りも声のキャラクター性に合わせて調整してください」)。
//   off の時は声の入る前の稽古 (止めの札は tut_focus.ts FOCUS_STEPS の一言・上の掲示は render.ts drawTutorialPrompts の文)。
//   ここは台本 (言葉) と見た目の選択だけ。描くのは src/tut_voice_view.ts。URL は game.ts の DEV の箱の中だけで読む。
//   口調は台帳 docs/ledger/story.md「いまの仕様（声）」: 人懐っこく、ちょっとおしゃべりな軽口で、褒めもする (10-31 作者「基本的には…人懐っこいというか、
//   ちょっとおしゃべりな、軽口な感じ」)。語彙は LUNAIRE と同じ人 (崩した若者言葉は使わない)。わざわざ短くしない (作者「わざわざ短くする必要はないかな」)。
//   「——」は間が空く所だけ。文頭には付けない (作者「くどいから、いらないです」「毎回使うとくどい」)。
//   画面の言葉 (パリィ・ガード・体幹・回避・回避カウンター・赤黒いオーラ・致命の一撃) はそのまま使う。「大丈夫」「よくできた」と「いま」は書かない。
//   記録 = docs/research/2026-10-31-tutorial-voice.md
import type { TutorialFocusStepId } from './types'

/** text = 今の真鍮の札のまま言葉だけ声に。a 金の囁き／b 吹き出し／c 上の帯の字幕／d レースの札。 */
export type TutVoiceLook = 'text' | 'a' | 'b' | 'c' | 'd'
export const TUT_VOICE_LOOKS: readonly TutVoiceLook[] = ['text', 'a', 'b', 'c', 'd']

let look: TutVoiceLook | null = 'a'

/** 指定なし・知らない値 = 配布版の a。off = 声の入る前の稽古 (null)。 */
export function setTutVoice(value: string | null | undefined): TutVoiceLook | null {
  if (value === 'off') look = null
  else look = (TUT_VOICE_LOOKS as readonly string[]).includes(value ?? '') ? (value as TutVoiceLook) : 'a'
  return look
}

/** 声が語る時の見た目。配布版は a。?tutVoice=off の時だけ null。 */
export function tutVoiceLook(): TutVoiceLook | null {
  return look
}

/** 止めた場面の声 (FOCUS_STEPS の一言と置き替える)。hint を書いた場面だけ、ボタンの横の小さな字も替える。 */
export const VOICE_FOCUS: Record<TutorialFocusStepId, { line: string; hint?: string }> = {
  hud_self: { line: '左上にあるのが、あなたの体力と体幹。ときどき見てあげてね' },
  hud_boss: { line: '下にあるのは、相手の体力と体幹。こっちも見ておいてね' },
  parry_timing: { line: '当たる直前に、パリィしてみて。早すぎても遅すぎても、だめなの' },
  guard_timing: { line: '押したままにすると、ガードになるの。こっちは受け止めるだけ' },
  exec_break: { line: '受けてばかりだと、あなたの体幹が溜まりきって、崩れちゃうの' },
  exec_timing: { line: '紫に光る一撃は、パリィでしか弾けないの。よく見ててね' },
  thrust_evade: { line: '赤黒いオーラの攻撃は、パリィできないの。回避してね' },
  grab_evade: { line: '赤黒いオーラの攻撃は、パリィできないの。回避してね' },
  counter_timing: { line: '避けたら、すぐ斬り返して。それが、回避カウンター' },
  zone_walk: { line: '床に波が広がったら、歩いて外へ出て。踏んだままだと、痛いよ' },
  finale_red: { line: '相手のゲージが赤く光ったら、パリィで崩せるよ。狙ってみて' },
  finale_execute: { line: '崩れたね。近づいて、致命の一撃をあげて' },
  combo3_hold: { line: '3段目まで当てると、相手の体幹が戻らなくなるの。覚えておいてね' },
}

/** 上の掲示の声 (課題の goal ごと)。{parry} などは render.ts と同じく押すボタンの名へ直してから出す。 */
export const VOICE_GOAL: Record<string, string> = {
  parry: '{parry} で、パリィしてみて。何回か、続けてね',
  just_parry: 'ぎりぎりまで引きつけて、パリィして。白い火花が散ったら、ぴったりだよ',
  guard: '{parry} を押したまま、斬撃を受け止めてみて',
  exec_parry: '押したまま、受け続けて。あなたが崩れたら、紫に光る一撃を {parry} で弾いて',
  zone_evade: '波の外まで、歩いて逃げて。急がなくても、間に合うよ',
  combo3: '{attack} を続けて、3段目まで当ててみて。途中でやめないでね',
  counter: '赤黒いオーラの攻撃は、{step} で避けて。すぐに {attack} で回避カウンター',
  finale: '斬って、パリィして、相手の体幹を崩して。覚えたこと、全部使っていいよ',
  finale_staggered: '崩れたよ。近づいて、{attack} で致命の一撃',
}

/** 声の比較版で、抜けた一拍の声を出しておく秒数。配布版の一拍 (TUT_SIX.clearShowSec 0.9) では、一字ずつ出し切ってから
 *  約0.5秒しか読めない。褒める一言を読み切れるよう、声の時だけ延ばす (2026-10-31)。 */
export const VOICE_CLEAR_SHOW_SEC = 1.6

/** 課題を抜けた一拍に添える声。課題の goal ごと。褒めてから、軽く次へ送る。 */
export const VOICE_CLEAR: Record<string, string> = {
  parry: 'うん、その感じ。もう覚えたね',
  just_parry: '火花、きれいに散ったね。ぴったり',
  guard: 'ちゃんと、受け止められたね',
  exec_parry: 'ほら、弾けた。紫も、怖くないでしょ？',
  zone_evade: 'うん、外まで出られたね',
  combo3: 'ほら、戻らなくなった。3段目が、大事なの',
  counter: 'うん、きれいに返せたね。次に行こうか',
}

/** 掲示の上の小さな見出し。課題の名は声の外の札として小さく残す。 */
export function voiceHeader(lessonNo: number, total: number, label: string | null): string {
  return label ? `稽古 ${lessonNo} / ${total}　${label}` : '仕上げ'
}

/** 課題の goal を台本の鍵へ (render.ts の掲示の分岐と同じ・どれにも当たらない課題は回避カウンター)。 */
export function voiceGoalKey(goal: string | undefined): string {
  return goal && goal in VOICE_GOAL ? goal : 'counter'
}

/** 掲示の声の文がいつ替わったか (出方の演出を文の替わり目から始める)。描く側だけの覚え書き。 */
let bannerSeen: { text: string; at: number } | null = null
export function voiceBannerAge(text: string, time: number): number {
  if (!bannerSeen || bannerSeen.text !== text || time < bannerSeen.at) bannerSeen = { text, at: time }
  return time - bannerSeen.at
}
